import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constants/colors";
import axios from "axios";
const UserPassword = () => {
  const [students, setStudents] = useState([]);
  const [showPasswords, setShowPasswords] = useState(false);
  const [loading, setLoading] = useState(true);
const [teacher, setTeacher] = useState(null);
const [modalOpen, setModalOpen] = useState(false);
const [step, setStep] = useState(1);
const [username, setUsername] = useState("");
const [otp, setOtp] = useState("");
const [userMobile, setUserMobile] = useState("");
const [newPassword, setNewPassword] = useState("");
const [message, setMessage] = useState("");

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/users`;

const handleResetClick = (student) => {
  setUsername(student.username); // ✅ ONLY current student
  setStep(1);
  setOtp("");
  setNewPassword("");
  setUserMobile("");
  setMessage("");
  setModalOpen(true);
};

const sendOtp = async () => {
  try {
    const res = await axios.post(`${API_BASE}/forgot-password`, { username });
    setUserMobile(res.data.mobile);
    setMessage("OTP sent to student's WhatsApp number!");
    setStep(2);
  } catch (err) {
    setMessage("Error sending OTP");
  }
};

const verifyOtp = async () => {
  try {
    const res = await axios.post(`${API_BASE}/verify-otp`, {
      mobile: userMobile,
      otp,
    });

    if (res.data.success) {
      setMessage("OTP verified!");
      setStep(3);
    } else {
      setMessage(res.data.message);
    }
  } catch {
    setMessage("Invalid OTP");
  }
};

const changePassword = async () => {
  try {
    const res = await axios.post(`${API_BASE}/update-password`, {
      username,
      newPassword,
    });

    if (res.data.success) {
      setMessage("Password updated successfully!");
      setTimeout(() => setModalOpen(false), 1000);
    } else {
      setMessage(res.data.message);
    }
  } catch {
    setMessage("Error updating password");
  }
};

useEffect(() => {
  const fetchData = async () => {
    try {
      const teacher = JSON.parse(localStorage.getItem("teacher"));

const teacherId = teacher?.id;
      const token = localStorage.getItem("token");
const sessionId = localStorage.getItem("currentSessionId");
      if (!teacherId) {
        console.error("Teacher ID not found");
        return;
      }

      // 🔹 STEP 1: Fetch teacher data
      const teacherRes = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacherId}?sessionId=${sessionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          
        }
      );

      const teacherData = await teacherRes.json();
      setTeacher(teacherData);

      if (!teacherData.classIncharge) {
        console.error("Teacher is not class in-charge");
        setStudents([]);
        return;
      }

      // 🔹 STEP 2: Fetch students using classIncharge
     const studentsRes = await fetch(
  `${process.env.REACT_APP_API_BASE_URL}/api/students/user-password?classIncharge=${encodeURIComponent(
    teacherData.classIncharge
  )}&sessionId=${sessionId}`
);

if (!studentsRes.ok) {
  const err = await studentsRes.json();
  console.error("Student API error:", err.message);
  setStudents([]); // ✅ always keep students as array
  return;
}

const studentsData = await studentsRes.json();
setStudents(Array.isArray(studentsData) ? studentsData : []);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);


  // Copy to clipboard
  const handleCopy = () => {
    const text = students
      .map(
        (s) =>
          `${s.name} — Username: ${s.username}, Password: ${s.password}`
      )
      .join("\n");

    navigator.clipboard.writeText(text);
    alert("Copied student credentials to clipboard ✅");
  };

  const handleExportCSV = () => {
    const csvRows = [
      ["Name", "Username", "Password"],
      ...students.map((s) => [s.name, s.username, s.password]),
    ];

    const csvContent =
      "data:text/csv;charset=utf-8," +
      csvRows.map((r) => r.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "student_passwords.csv";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-white flex justify-center">
      <div className="max-w-7xl w-full px-6 lg:pl-34 py-12">
        <header className="mb-10 flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <h1 className="text-4xl font-bold text-gray-900 mb-4 sm:mb-0">
            Student Usernames & Passwords
          </h1>

          <Link
            to="/dashboard"
            className="text-sm sm:text-base font-semibold text-white px-4 py-2 rounded-md transition-transform duration-300 hover:scale-105"
            style={{
              background: colors.gradientPrimary,
              boxShadow: `0 4px 8px ${colors.cardShadow}`,
            }}
          >
            ← Back to Dashboard
          </Link>
        </header>


        {loading ? (
          <p className="text-gray-600">Loading students...</p>
        ) : (
          <div className="bg-gray-100 rounded-lg shadow-md p-6 overflow-x-auto">
            <table className="min-w-full text-left border-collapse">
              <thead>
                <tr className="bg-gray-200 text-gray-800">
                  <th className="py-3 px-4 border-b">#</th>
                  <th className="py-3 px-4 border-b">Student Name</th>
                  <th className="py-3 px-4 border-b">Username</th>
                  <th className="py-3 px-4 border-b">Password</th>

                </tr>
              </thead>

              <tbody>
                {students.map((student, index) => (
                  <tr
                    key={student.id}
                    className="hover:bg-gray-50 transition duration-150"
                  >
                    <td className="py-3 px-4 border-b">{index + 1}</td>
                    <td className="py-3 px-4 border-b font-medium text-gray-900">
                      {student.name}
                    </td>
                    <td className="py-3 px-4 border-b text-gray-700">
                      {student.username}
                    </td>
                    <td className="py-3 px-4 border-b text-gray-700">
  <button
    onClick={() => handleResetClick(student)}
    className="bg-red-500 hover:bg-red-600 text-white text-center px-3 py-1 rounded"
  >
    Reset
  </button>
</td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Actions */}
        {/* <div className="mt-6 flex flex-col sm:flex-row sm:justify-start gap-3 sm:gap-4 flex-wrap">
          <button
            onClick={handleExportCSV}
            className="px-4 sm:px-6 py-2 rounded-md font-semibold text-white transition-transform duration-300 hover:scale-105"
            style={{
              background: colors.gradientPrimary,
              boxShadow: `0 4px 8px ${colors.cardShadow}`,
            }}
          >
            Export CSV
          </button>

          <button
            onClick={handleCopy}
            className="px-4 sm:px-6 py-2 rounded-md font-semibold text-gray-800 bg-gray-200 hover:bg-gray-300 transition-transform duration-300"
          >
            Copy to Clipboard
          </button>

          <button
            onClick={() => setShowPasswords(!showPasswords)}
            className="px-4 sm:px-6 py-2 rounded-md font-semibold text-gray-800 bg-gray-200 hover:bg-gray-300 transition-transform duration-300"
          >
            {showPasswords ? "Hide Passwords" : "Show Passwords"}
          </button>
        </div> */}
      </div>
      {modalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 w-full max-w-md">
      <h2 className="text-xl font-semibold mb-4">
        Reset Password for {username}
      </h2>

      {message && (
        <p className={`mb-4 ${message.includes("Error") ? "text-red-600" : "text-green-600"}`}>
          {message}
        </p>
      )}

      {step === 1 && (
        <button
          onClick={sendOtp}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Send OTP
        </button>
      )}

      {step === 2 && (
        <>
          <input
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP"
            className="border p-2 rounded w-full mb-4"
          />
          <button
            onClick={verifyOtp}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Verify OTP
          </button>
        </>
      )}

      {step === 3 && (
        <>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="New Password"
            className="border p-2 rounded w-full mb-4"
          />
          <button
            onClick={changePassword}
            className="bg-purple-500 text-white px-4 py-2 rounded"
          >
            Update Password
          </button>
        </>
      )}

      <button
        className="mt-4 text-gray-500 underline w-full"
        onClick={() => setModalOpen(false)}
      >
        Close
      </button>
    </div>
  </div>
)}

    </div>
  );
};

export default UserPassword;
